import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Box from '../../../Box/index.esm.js';
import CloseButton from '../../../CloseButton/index.esm.js';
import Flex from '../../../Flex/index.esm.js';
import ContentEditable from '../ContentEditable/index.esm.js';
import useTagStyles from './styles.esm.js';

var Tag = function Tag(_ref) {
  var value = _ref.value,
      index = _ref.index,
      editable = _ref.editable,
      readOnly = _ref.readOnly,
      inputRef = _ref.inputRef,
      update = _ref.update,
      _remove = _ref.remove,
      validator = _ref.validator,
      removeOnBackspace = _ref.removeOnBackspace,
      allowLineBreak = _ref.allowLineBreak,
      size = _ref.size;
  var innerEditableRef = React__default.createRef();

  var _useTagStyles = useTagStyles({
    size: size,
    allowLineBreak: allowLineBreak
  }),
      tagStyleProps = _useTagStyles.tagStyleProps,
      tagContentStyleProps = _useTagStyles.tagContentStyleProps,
      closeButtonStyleProps = _useTagStyles.closeButtonStyleProps;

  return React__default.createElement(Flex, _extends({}, tagStyleProps), editable ? React__default.createElement(ContentEditable, {
    value: value,
    inputRef: inputRef,
    innerEditableRef: innerEditableRef,
    change: function change(newValue) {
      return update(index, newValue);
    },
    remove: function remove() {
      return _remove(index);
    },
    validator: validator,
    removeOnBackspace: removeOnBackspace,
    styleProps: tagContentStyleProps
  }) : React__default.createElement(Box, _extends({}, tagContentStyleProps), value), !readOnly && React__default.createElement(CloseButton, _extends({
    tabIndex: -1,
    onClick: function onClick() {
      return _remove(index);
    }
  }, closeButtonStyleProps)));
};

export default Tag;
//# sourceMappingURL=index.esm.js.map
